import { Box, Checkbox } from "@mui/material";
import { Menu, MenuItem, Select, Slider } from "@mui/material";
import { TextField, Typography } from "@mui/material";
import { styles } from "../../pages/Tracks/styles";
import { APP_BACKGROUND_COLOR, APP_COLOR } from "../../theme";
import { FONT_FAMILY } from "../../theme";
import { GenresArray } from "../../components/constants";
import { CustomPaper, SelectField } from "../../pages/MyTracks/styles";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useStyles } from "../../pages/MyTracks/styles";
import {
  CustomFilterMenuContainer,
  FilterAndSortButton,
  filterMenuStyles,
} from "./styles";
import { FilterMenuProps, versionState } from "./types";
import FilterListIcon from "@mui/icons-material/FilterList";
import { ReactNode, useState, useEffect } from "react";
import CustomButton from "../CustomButton/CustomButton";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
export enum PRIVACY_OPTIONS {
  ALL = "All",
  PUBLIC = "Public",
  PROVATE = "Private",
}

export const FilterMenu: React.FC<FilterMenuProps> = ({
  allArtistList,
  collaboratorsOptionsList,
  filterAndSortParams,
  value: tabValue,
  setFilterAndSortParams,
  handleFiltersAndSort,
  setPage,
  setTracks,
}) => {
  const [bpm, setBpm] = useState([0, 200]);
  const [filterAnchorEl, setFilterAnchorEl] = useState<null | HTMLElement>(
    null
  );
  const openFilterMenu = Boolean(filterAnchorEl);
  const classes = useStyles();

  const handleFilterDropdownClose = () => {
    setFilterAnchorEl(null);
  };

  const handleOpenFilterDropdown = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleBpmFilter = async (
    _event: React.SyntheticEvent | Event,
    value: number | number[]
  ) => {
    if (Array.isArray(value)) {
      const bpmFilter = value as number[];
      setBpm(bpmFilter);
      setFilterAndSortParams((prev) => {
        return {
          ...prev,
          bpmStartValue: bpmFilter[0],
          bpmEndValue: bpmFilter[1],
        };
      });
    }
  };

  const handleChangeCollaboratorsList = async (
    _event: React.SyntheticEvent<Element, Event>,
    value: unknown
  ) => {
    const values = value as Array<string>;
    const tempArr: string[] = [];
    const length = values.length;
    for (let i = 0; i < length; i++) {
      const tag_curr = values[i];
      tempArr.push(tag_curr);
    }
    setFilterAndSortParams((prev) => {
      return {
        ...prev,
        collaboratorsList: [...tempArr],
      };
    });
  };

  useEffect(() => {
    if (tabValue === 2) {
      setFilterAndSortParams((prev) => ({
        ...prev,
        status: "5",
      }));
    } else {
      setFilterAndSortParams((prev) => ({
        ...prev,
        status: prev.status,
      }));
    }
  }, [tabValue, setFilterAndSortParams]);

  return (
    <>
      <FilterAndSortButton
        aria-controls={openFilterMenu ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openFilterMenu ? "true" : undefined}
        onClick={handleOpenFilterDropdown}
        sx={styles.filterButton}
      >
        <FilterListIcon sx={{ margin: "10px" }} />
        Filters
      </FilterAndSortButton>
      <Menu
        id="basic-menu"
        anchorEl={filterAnchorEl}
        open={openFilterMenu}
        onClose={handleFilterDropdownClose}
        PaperProps={{
          style: filterMenuStyles.menuPaperProps,
        }}
        sx={filterMenuStyles.menu}
      >
        <Box sx={filterMenuStyles.filterMenuBox}>
          <Typography variant="h5">Filters</Typography>
          <CustomFilterMenuContainer>
            <Box>
              <Box sx={filterMenuStyles.genreContainer}>
                Genre
                <SelectField
                  style={filterMenuStyles.selectAndTextField}
                  options={GenresArray}
                  disableCloseOnSelect
                  onChange={(_e, value) => {
                    setFilterAndSortParams((prev) => {
                      return {
                        ...prev,
                        genreList: [value as string],
                      };
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      sx={filterMenuStyles.selectAndTextField}
                      {...params}
                      label={""}
                      InputLabelProps={{ shrink: false }}
                      classes={{ root: classes.customTextField }}
                    />
                  )}
                  PaperComponent={CustomPaper}
                />
              </Box>
              <Box sx={filterMenuStyles.collaboratorsContainer}>
                Collaborators
                <SelectField
                  multiple
                  style={filterMenuStyles.selectAndTextField}
                  id="collaborator-tags"
                  options={collaboratorsOptionsList}
                  disableCloseOnSelect
                  onChange={handleChangeCollaboratorsList}
                  renderOption={(props, option, { selected }) => (
                    <li {...props} style={{ fontFamily: FONT_FAMILY }}>
                      <>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option as ReactNode}
                      </>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      sx={filterMenuStyles.selectAndTextField}
                      {...params}
                      label={""}
                      InputLabelProps={{ shrink: false }}
                      classes={{ root: classes.customTextField }}
                    />
                  )}
                  PaperComponent={CustomPaper}
                />
              </Box>
              {tabValue !== 2 && (
                <Box sx={filterMenuStyles.privacyContainer}>
                  Track Status
                  <Select
                    sx={filterMenuStyles.privacySelect}
                    value={filterAndSortParams?.status}
                    MenuProps={{
                      PaperProps: {
                        sx: filterMenuStyles.genreMenuProps,
                      },
                    }}
                    onChange={(e) => {
                      setFilterAndSortParams((prev) => {
                        return {
                          ...prev,
                          status:
                            tabValue === 0
                              ? e.target.value
                              : tabValue === 2
                              ? "5"
                              : e.target.value,
                        };
                      });
                    }}
                  >
                    {Object.entries(versionState)
                      .filter(
                        ([key, value]) => !(tabValue === 0 && key === "5")
                      )
                      .map(([key, value], i) => {
                        const formattedValue =
                          value.charAt(0).toUpperCase() +
                          value.slice(1).toLowerCase();

                        return (
                          <MenuItem
                            key={i}
                            value={key}
                            sx={{ backgroundColor: APP_BACKGROUND_COLOR }}
                            classes={{ root: classes.selectStyle }}
                          >
                            {formattedValue}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </Box>
              )}
            </Box>
            <Box sx={filterMenuStyles.filterRightSideBox}>
              <Box>
                <Box sx={filterMenuStyles.artistContainer}>
                  Artist
                  <SelectField
                    style={filterMenuStyles.selectAndTextField}
                    options={allArtistList}
                    disableCloseOnSelect
                    onChange={(_e, value) => {
                      setFilterAndSortParams((prev) => {
                        return {
                          ...prev,
                          artistList: [value as string],
                        };
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        sx={filterMenuStyles.selectAndTextField}
                        {...params}
                        label={""}
                        InputLabelProps={{ shrink: false }}
                        classes={{ root: classes.customTextField }}
                      />
                    )}
                    PaperComponent={CustomPaper}
                  />
                </Box>
                <Box sx={filterMenuStyles.privacyContainer}>
                  Track Privacy
                  <Select
                    sx={filterMenuStyles.privacySelect}
                    value={filterAndSortParams?.TrackPrivacy}
                    MenuProps={{
                      PaperProps: {
                        sx: filterMenuStyles.genreMenuProps,
                      },
                    }}
                    onChange={(e) => {
                      setFilterAndSortParams((prev) => {
                        return {
                          ...prev,
                          TrackPrivacy: e.target.value,
                        };
                      });
                    }}
                  >
                    {Object.values(PRIVACY_OPTIONS).map((el, i) => {
                      return (
                        <MenuItem
                          key={i}
                          value={el}
                          sx={{ backgroundColor: APP_BACKGROUND_COLOR }}
                          classes={{ root: classes.selectStyle }}
                        >
                          {el}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Box>
                <Box sx={filterMenuStyles.bpmContainer}>
                  BPM &nbsp;({filterAndSortParams?.bpmStartValue} -{" "}
                  {filterAndSortParams?.bpmEndValue})
                  <Slider
                    id="step-6"
                    size="medium"
                    defaultValue={bpm}
                    sx={{ color: APP_COLOR, marginTop: "10px" }}
                    valueLabelDisplay="auto"
                    min={0}
                    max={200}
                    onChange={handleBpmFilter}
                    onChangeCommitted={handleBpmFilter}
                  />
                </Box>
              </Box>
            </Box>
          </CustomFilterMenuContainer>
          <Box sx={filterMenuStyles.buttonsContainer}>
            <CustomButton
              text="Apply"
              onClick={async () => {
                setTracks([]);
                setPage(0);
                await handleFiltersAndSort();
                handleFilterDropdownClose();
              }}
              customStyles={{ width: "150px" }}
            />
            <CustomButton
              text="Cancel"
              onClick={handleFilterDropdownClose}
              isSkipButton={true}
              customStyles={{ width: "150px" }}
            />
          </Box>
        </Box>
      </Menu>
    </>
  );
};
